<template>
  <el-dialog
    title="修改密码"
    :visible.sync="visible"
    append-to-body
    v-dialogDrag
    width="600px"
    top="30px"
    :close-on-click-modal="false"
  >
    <el-form
      @submit.native.prevent
      :model="form"
      :rules="rules"
      status-icon
      ref="form"
      label-position="right"
      label-width="80px"
    >
      <el-form-item label="原密码" prop="oldPwd" :rules="$g.validRequired">
        <PwdInput
          v-model.trim="form.oldPwd"
          placeholder="原密码"
          clearable
        ></PwdInput>
      </el-form-item>
      <el-form-item label="新密码" prop="newPwd" :rules="$g.validRequired">
        <PwdInput
          v-model.trim="form.newPwd"
          placeholder="新密码"
          clearable
        ></PwdInput>
      </el-form-item>
      <el-form-item label="确认密码" prop="modifPwd">
        <PwdInput
          v-model.trim="form.modifPwd"
          placeholder="确认密码"
          clearable
        ></PwdInput>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="canale" @click="visible = false">关闭</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import PwdInput from "@/components/PwdInput.vue";
export default {
  components: {
    PwdInput,
  },
  props: {
    item: {},
  },
  data() {
    return {
      visible: false,
      form: {
        oldPwd: "",
        newPwd: "",
        modifPwd: "",
      },
      rules: {
        modifPwd: [{ validator: this.compareToFirstPassword }],
      },
    };
  },
  watch: {
    item(v) {
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
      this.visible = true;
    },
  },
  mounted() {},
  methods: {
    compareToFirstPassword(rule, value, callback) {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.newPwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return;
        }
        this.$put("User/ChangePwdBySelf", {
          OldPassword: this.form.oldPwd,
          NewPassword: this.form.newPwd,
        }).then((r) => {
          this.$message.success("操作成功");
          this.visible = false;
          this.$emit("success", r);
        });
      });
    },
  },
};
</script>

<style>
</style>